// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cv-b";
export var colorBlue = "_cv-8";
export var colorDot = "_cv-0";
export var colorDotLarge = "_cv-2";
export var colorDotSmall = "_cv-1";
export var colorGreen = "_cv-7";
export var colorGrey = "_cv-3";
export var colorOrange = "_cv-5";
export var colorPink = "_cv-a";
export var colorPurple = "_cv-9";
export var colorRed = "_cv-4";
export var colorYellow = "_cv-6";